import { render, staticRenderFns } from "./newStuff.vue?vue&type=template&id=53066cc2"
import script from "./newStuff.vue?vue&type=script&lang=js"
export * from "./newStuff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports